import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlimScrollModule } from 'ng2-slimscroll';

import { SharedModule } from './../shared/shared.module';
import { AuthenticationRoutingModule } from './authentication-routing.module';
import { SigninComponent } from './signin/signin.component';
import { TermsComponent } from './terms/terms.component';
import { LogoutComponent } from './logout/logout.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { SignupComponent } from './signup/signup.component';
import { VendorProfileComponent } from './vendor-profile/vendor-profile.component';
import { ChangePasswordPopupComponent } from './change-password/change-password.component';

@NgModule({
  imports: [
    CommonModule,
    AuthenticationRoutingModule,
    SharedModule,
    SlimScrollModule
  ],
  declarations: [SigninComponent, TermsComponent, LogoutComponent, ForgetPasswordComponent, ChangePasswordPopupComponent, SignupComponent, VendorProfileComponent]
})
export class AuthenticationModule { }



// WEBPACK FOOTER //
// ./src/app/authentication/authentication.module.ts